import React from "react";

import {useTranslation} from "react-i18next";
import {Grid, Icon} from "@mui/material";

import MDLoadingButton from "../MDLoadingButton";

import Stack from "@mui/material/Stack";
import MDButton from "materialDashboard/components/MDButton";
import MDTypography from "materialDashboard/components/MDTypography";


const PermissionHeader = ({title, ruleState, changesCount, onCancel, onApply}) => {
    return <Grid container mb={3}>
        <Grid item sm={3} >
            <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                {title}
            </MDTypography>
        </Grid>
        <Grid item sm={9}>
            <PermissionsToolbar ruleState={ruleState}
                                changesCount={changesCount}
                                onCancel={onCancel}
                                onApply={onApply}/>
        </Grid>
    </Grid>
}

const PermissionsToolbar = ({changesCount, onCancel, onApply}) => {
    const {t} = useTranslation(["acl"]);
    return <Stack direction="row" spacing={2} ml={"auto"} alignItems="center" justifyContent="flex-end">
        <MDTypography variant="body2">
            {
                changesCount === 0 ?
                    t('table.noChanges')
                    :
                    t('table.changes', {count: changesCount})
            }
        </MDTypography>
        <MDButton variant="outlined" color="info" disabled={changesCount === 0} onClick={onCancel}>
            {t('table.cancel')}
        </MDButton>
        <MDLoadingButton variant="gradient"
                         color="info"
                         loading={false}
                         onClick={() => onApply()}
                         disabled={changesCount === 0}
                         startIcon={<Icon>save</Icon>}>
            {t('table.submit')}
        </MDLoadingButton>
    </Stack>
}

export default PermissionHeader;